export const StandardComponentType = 'standard';
export const StatusComponentType = 'status';
export const StatusTimelineComponentType = 'status_timeline';
export const TimelineComponentType = 'timeline';
export const ImageComponentType = 'image';
export const TextComponentType = 'text';

const ComponentTypes = [
  StandardComponentType,
  StatusComponentType,
  StatusTimelineComponentType,
  TimelineComponentType,
  ImageComponentType,
  TextComponentType,
];

export default ComponentTypes;
